<script>
export default {
    name: 'IconPlayLight',
}
</script>
<template>
   <svg class="base-icon icon-play-light" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  d="M14.385 15.016v33.959l28.297-16.98-28.297-16.98ZM8.53.334l49.31 29.586c.353.213.647.517.85.882a2.467 2.467 0 0 1 0 2.4c-.203.366-.497.67-.85.883L8.53 63.671a2.297 2.297 0 0 1-2.358.005 2.38 2.38 0 0 1-.86-.89A2.466 2.466 0 0 1 5 61.572V2.414c0-.425.109-.842.315-1.21a2.38 2.38 0 0 1 .863-.883 2.296 2.296 0 0 1 2.35.008v.005Z"/></svg>
</template>
